module.exports = __webpack_public_path__ + "img/fm.df6aa931.jpg";